export default "__VITE_ASSET__dcfbac0b__"